<template>
  <div style="height: 100%;">
    <van-nav-bar title="用户注册及协同宝App隐私协议" left-text="" left-arrow @click-left="onClickLeft" />
    <uesrLicenseVue class="uesrLicenseStyle" />
  </div>
</template>
<script>
import uesrLicenseVue from "./compontent/uesrLicense.vue";
import * as uni from "./../component/uni.webview.1.5.2.js";
import Vue from "vue";
document.addEventListener("UniAppJSBridgeReady", function() {
  Vue.prototype.myUni = uni;
});
export default {
  components: { uesrLicenseVue },
  methods: {
    onClickLeft() {
      uni.navigateBack({ delta: 1 });
      this.$router.back();
    }
  }
};
</script>
<style lang="scss" scoped>
.uesrLicenseStyle{
  height: calc(100% - 46px);
  padding: 10px;
  overflow-y: auto;
}
</style>
